import React from 'react'

export default function InviteRejected(props) {
    return (<h1 style={{textAlign: 'center'}}>This invite has already been rejected</h1>)
}
